export const transactions_header = {
  title: "Transactions",
  sync_now: "Sync now",
  sync_success: "Synced {upserted} of {scanned} transactions",
  sync_error: "Could not sync Mercury transactions",
  spoof: "Spoof transaction",
  spoof_dialog_title: "Spoof Mercury transaction",
  spoof_amount_label: "Amount (USD, signed)",
  spoof_amount_hint: "Positive = inbound payment, negative = outbound",
  spoof_counterparty_label: "Counterparty",
  spoof_submit: "Add to mock Mercury",
  spoof_cancel: "Cancel",
  spoof_success:
    "Added to mock Mercury. Click Sync now to pull it into the local mirror.",
  spoof_error: "Could not spoof Mercury transaction",
};
